<template>
    <div class="about">
        <menuBox :step="2"></menuBox>
        <div class="about-box">
            Delete account
        </div>
        <div class="content">
            <div class="title">
                Uniquely matrix economically sound value through cooperative technology. Competently parallel task fully
                researched data and enterprise process improvements. Collaboratively expedite quality manufactured
                products via client-focused results quickly communicate enabled technology and turnkey leadership
                skills. Uniquely enable accurate supply chains rather than friction technology.
            </div>
            <div class="list">
                1. The account will not be able to be logged in;<br>
                2. If you have enough gold coins, all reward coins obtained will be cleared and cannot be used;<br>
                3. The collected short dramas, viewing history and other data will be cleared;<br>
                4. Give up all recharge benefits and coupons;<br>
                5. Personal information and other contents will be permanently invalid;
            </div>
            <div class="kind">
                <p>Kind tips:</p>
                <span>After deleting your account, all your data and account information will be lost. Once your account
                    is deleted, it cannot be recovered. To avoid your personal losses, please operate with
                    caution.</span>
            </div>
            <div class="imgList">
                <div class="bt">In order to confirm that it is the user himself and to protect the security of your
                    information and property, please download the app, log in, and delete the account in Personal Center
                    - Delete Data</div>
                <div class="item">
                    <img src="../assets/deleteG.png" alt="" @click="changeRoute(1)">
                    <img src="../assets/deleteA.png" alt="" @click="changeRoute(2)">
                </div>
            </div>
        </div>
        <footerBox :step="2"></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: "App",
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            val: ''
        };
    },
    mounted() { },
    methods: {
        changeRoute(val) {
            if (val == 1) {
                window.location.href = "https://play.google.com/store/apps/details?id=com.reelbuzz.tv"
            } else {
                window.location.href = "https://apps.apple.com/id/app/reelbuzz/id6480157261"
            }
        }
    },
};
</script>
<style lang="less" scoped>
.about-box {
    position: relative;
    top: -100px;
    background-image: url(../assets/delete.png);
    width: 100%;
    height: 300px;
    background-size: 100% 100%;
    padding: 130px 360px 0 360px;
    font-family: Poppins, Poppins;
    font-weight: bold;
    font-size: 52px;
    color: #FFFFFF;
    line-height: 61px;
    text-align: center;
    box-sizing: border-box;
}

.content {
    padding: 0 360px 200px;
    color: #4E4E4E;
    font-style: 20px;

    .title {
        margin-bottom: 24px;
        font-family: Lexend, Lexend;
        line-height: 34px;
        font-size: 22px;
        color: #333333;
    }

    .list {
        margin-bottom: 40px;
        font-family: Lexend, Lexend;
        font-size: 20px;
        color: #6A6A6A;
        line-height: 60px;
    }

    .kind {
        margin-bottom: 125px;
        padding: 24px;
        box-sizing: border-box;
        border-left: 7px solid #191A20;
        background: #F3F4F5;

        p {
            color: #333333;
        }

        span {
            color: #6A6A6A;
        }
    }

    .imgList {
        padding: 50px 100px;
        background: #F3F4F5;

        .bt {
            font-family: Lexend, Lexend;
            font-weight: 500;
            font-size: 24px;
            color: #333333;
            line-height: 40px;
            text-align: center;
        }

        .item {
            margin-top: 50px;
            text-align: center;

            img {
                cursor: pointer;
                margin-right: 30px;
                width: 293px;
                height: 86px;
            }
        }
    }

}
</style>